// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f16171ed","455":"e9679428","977":"4f647b26"}[chunkId] + ".chunk.js";
};